import React from 'react';
import { useAuth } from '../../context/AuthContext';
import RequiredDocumentTypesManager from '../../components/RequiredDocumentTypesManager';

const DocumentSettingsPage = () => {
  const { user, hasModule } = useAuth();
  const enabled = hasModule('document_submission');

  return (
    <div className="space-y-6" data-testid="document-settings-page">
      <div>
        <h1 className="text-3xl font-semibold text-slate-900">Document Settings</h1>
        <p className="text-slate-500 mt-1">
          Configure the document types your users are required to submit.
        </p>
      </div>

      {!enabled && (
        <div className="p-4 bg-amber-50 border border-amber-200 rounded-lg text-sm text-amber-800">
          The <strong>Document Submission</strong> module is not enabled for your organization.
          Contact your platform administrator to enable it.
        </div>
      )}

      {user?.tenant_id && (
        <RequiredDocumentTypesManager tenantId={user.tenant_id} enabled={enabled} />
      )}
    </div>
  );
};

export default DocumentSettingsPage;
